var _rect, _rect2, _rect3, _rect4, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColoredlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.4453,
    y: 35.9863,
    width: 54.3791,
    height: 54.3791,
    rx: 13.5948,
    fill: "url(#paint0_linear_10878_19259)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4453,
    y: 35.9863,
    width: 54.3791,
    height: 54.3791,
    rx: 13.5948,
    fill: "url(#paint1_linear_10878_19259)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4453,
    y: 35.9863,
    width: 54.3791,
    height: 54.3791,
    rx: 13.5948,
    fill: "url(#paint2_linear_10878_19259)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4453,
    y: 35.9863,
    width: 54.3791,
    height: 54.3791,
    rx: 13.5948,
    fill: "url(#paint3_linear_10878_19259)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6348 68.6137C62.6348 65.6104 65.0694 63.1758 68.0727 63.1758H112.042C116.887 63.1758 119.313 69.0332 115.888 72.4589L95.4661 92.8804L71.9179 116.429C68.4922 119.854 62.6348 117.428 62.6348 112.583V68.6137Z",
    fill: "url(#paint4_linear_10878_19259)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6348 57.7379C62.6348 60.7411 60.2001 63.1758 57.1969 63.1758H13.2271C8.38245 63.1758 5.95622 57.3184 9.38191 53.8927L29.8034 33.4712L53.3517 9.92293C56.7774 6.49724 62.6348 8.92345 62.6348 13.7681V57.7379Z",
    fill: "url(#paint5_linear_10878_19259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10878_19259",
    x1: 43.6022,
    y1: 97.1628,
    x2: 106.138,
    y2: 78.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10878_19259",
    x1: 43.6022,
    y1: 97.1628,
    x2: 106.138,
    y2: 78.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10878_19259",
    x1: 43.6022,
    y1: 97.1628,
    x2: 106.138,
    y2: 78.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10878_19259",
    x1: 43.6022,
    y1: 97.1628,
    x2: 106.138,
    y2: 78.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7236F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A778EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10878_19259",
    x1: 72.0152,
    y1: 133.529,
    x2: 143.931,
    y2: 111.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67F7DE",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10878_19259",
    x1: 53.2544,
    y1: -7.17716,
    x2: -18.662,
    y2: 14.7104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67F7DE",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredlogo);
export default __webpack_public_path__ + "static/media/coloredlogo.0e9b3e14d644b44e197f3294f2b5a099.svg";
export { ForwardRef as ReactComponent };